import React from 'react';
import { SvgIcon, SvgIconProps } from '@mui/material';

export const LandlordIcon: React.FC<SvgIconProps> = props => {
  return (
    <SvgIcon {...props}>
      <path d='M10 20V14H14V20H19V12H22L12 3L2 12H5V20H10Z' />
    </SvgIcon>
  );
};
